// import React, { useState, useEffect, useRef } from "react";
// import "./registrationfrom.css";
// import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
// import EditIcon from "../../Assets/Images/EployeeRegistration/edit_icon.png";
// import searchIcon from "../../Assets/Images/EployeeRegistration/search-icon.png";
// import { API_BASE_URL } from "../../Config/Config";

// function Address({ setAddress }) {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filteredCity, setFilteredCity] = useState([]);
//   const [selectedCity, setSelectedCity] = useState(null);
//   const [stateName, setStateName] = useState("");
//   const searchContainerRef = useRef(null);
//   const [searchPermCity, setSearchPermCity] = useState("");
//   const [filteredPermCity, setFilteredPermCity] = useState([]);
//   const [selectedPermCity, setSelectedPermCity] = useState(null);
//   const [stateNamePerm, setStateNamePermPerm] = useState("");
//   const searchPermCityRef = useRef(null);
//   const [isOpen, setIsOpen] = useState(false);
//   const [values, setValues] = useState({
//     loc_add1: "",
//     loc_add2: "",
//     loc_city_id: 0,
//     loc_pincode: "",
//     perm_add1: "",
//     perm_add2: "",
//     perm_city_id: 0,
//     perm_pincode: "",
//   });

//   const [sameAsLocal, setSameAsLocal] = useState(false);

//   setAddress(values);

//   const onChange = (e) => {
//     const { name, value } = e.target;
//     setValues({ ...values, [name]: value });
//     setAddress((prevInfo) => ({
//       ...prevInfo,
//       [name]: value,
//     }));
//   };

//   const handleCheckboxChange = (event) => {
//     setSameAsLocal(event.target.checked);
//     if (event.target.checked) {
//       setValues({
//         ...values,
//         perm_add1: values.loc_add1,
//         perm_add2: values.loc_add2,
//         perm_pincode: values.loc_pincode,
//         perm_city_id: values.loc_city_id,
//       });
//       setSearchPermCity(searchTerm);
//       setStateNamePermPerm(stateName);
//     } else {
//       setValues({
//         ...values,
//         perm_add1: "",
//         perm_add2: "",
//         perm_pincode: "",
//         perm_city_id: "",
//       });
//       setSearchPermCity("");
//       setStateNamePermPerm("");
//     }
//   };

//   const handleItemClickOne = (item) => {
//     setSelectedCity(item);
//     setSearchTerm(`${item.city_name}`);
//     setStateName(item.state_name);
//     setFilteredCity([]);
//     setValues((prevValues) => ({
//       ...prevValues,
//       loc_city_id: item.city_id,
//     }));
//     setAddress((prevInfo) => ({
//       ...prevInfo,
//       loc_city_id: item.city_id,
//     }));
//   };

//   const toggleAccordion = () => {
//     setIsOpen(!isOpen);
//   };

//   const handleSearchChange = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);
//     if (value.trim() === "") {
//       setFilteredCity([]);
//       setSelectedCity(null);
//       setStateName("");
//     } else if (value.length >= 2) {
//       handleSearchClick();
//     }
//   };

//   const handleSearchClick = () => {
//     console.log("Search term:", searchTerm);
//     if (searchTerm.trim() === "" || searchTerm.length < 2) {
//       setFilteredCity([]);
//       return;
//     }
//     // Using callback function to ensure the latest value of searchTerm is used
//     setSearchTerm((prevSearchTerm) => {
//       fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-city-list-serach_key/?search_key=${encodeURIComponent(
//           prevSearchTerm // Using prevSearchTerm which ensures the latest value
//         )}`
//       )
//         .then((response) => {
//           if (!response.ok) {
//             throw new Error("Network response was not ok");
//           }
//           return response.json();
//         })
//         .then((data) => {
//           const filtered = data.filter((item) =>
//             Object.values(item).some(
//               (val) =>
//                 typeof val === "string" &&
//                 val.toLowerCase().includes(prevSearchTerm.toLowerCase())
//             )
//           );
//           setFilteredCity(filtered);
//         })
//         .catch((error) => {
//           console.error(
//             "There was a problem with your fetch operation:",
//             error
//           );
//         });

//       // Returning prevSearchTerm to maintain the existing state
//       return prevSearchTerm;
//     });
//   };

//   const handleClickOutside = (event) => {
//     if (
//       searchContainerRef.current &&
//       !searchContainerRef.current.contains(event.target)
//     ) {
//       setFilteredCity([]);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("click", handleClickOutside);
//     return () => {
//       document.removeEventListener("click", handleClickOutside);
//     };
//   }, []);

//   // API CALL FOR PERMANANT CITY
//   const handleSearchChangePermCity = (e) => {
//     const value = e.target.value;
//     setSearchPermCity(value);
//     if (value.trim() === "") {
//       setFilteredPermCity([]);
//       setSelectedPermCity(null);
//       setStateNamePermPerm("");
//     } else if (value.length >= 3) {
//       handleSearchClickPermCity();
//     }
//   };

//   const handleSearchClickPermCity = () => {
//     console.log("Search Perm City:", searchPermCity);
//     if (searchPermCity.trim() === "" || searchPermCity.length < 2) {
//       setFilteredPermCity([]);
//       return;
//     }

//     // Using callback function to ensure the latest value of searchPermCity is used
//     setSearchPermCity((prevSearchPermCity) => {
//       fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-city-list-serach_key/?search_key=${encodeURIComponent(
//           prevSearchPermCity // Using prevSearchPermCity which ensures the latest value
//         )}`
//       )
//         .then((response) => {
//           if (!response.ok) {
//             throw new Error("Network response was not ok");
//           }
//           return response.json();
//         })
//         .then((data) => {
//           const filtered = data.filter((item) =>
//             Object.values(item).some(
//               (val) =>
//                 typeof val === "string" &&
//                 val.toLowerCase().includes(prevSearchPermCity.toLowerCase())
//             )
//           );
//           setFilteredPermCity(filtered);
//         })
//         .catch((error) => {
//           console.error(
//             "There was a problem with your fetch operation:",
//             error
//           );
//         });

//       // Returning prevSearchPermCity to maintain the existing state
//       return prevSearchPermCity;
//     });
//   };

//   const handleItemClickPermCity = (item) => {
//     setSelectedPermCity(item);
//     setSearchPermCity(`${item.city_name}`);
//     setStateNamePermPerm(item.state_name);
//     setFilteredPermCity([]);

//     // Update perm_city_id in values state
//     setValues((prevValues) => ({
//       ...prevValues,
//       perm_city_id: item.city_id,
//     }));

//     // Update the parent component's data
//     setAddress((prevInfo) => ({
//       ...prevInfo,
//       perm_city_id: item.city_id,
//     }));
//   };

//   const handleClickOutsidePerm = (event) => {
//     if (
//       searchPermCityRef.current &&
//       !searchPermCityRef.current.contains(event.target)
//     ) {
//       setFilteredPermCity([]);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("click", handleClickOutsidePerm);
//     return () => {
//       document.removeEventListener("click", handleClickOutsidePerm);
//     };
//   }, []);

//   return (
//     <div className="personal-info">
//       <div className="personal-header">
//         <div className="header">
//           <h2>ADDRESSES</h2>
//           <img src={EditIcon} alt="icon"/>
//         </div>
//         <div className="accordion-btn" onClick={toggleAccordion}>
//           {isOpen ? (
//             <div className="minus"></div>
//           ) : (
//             <div className="plus">+</div>
//           )}
//         </div>
//       </div>
//       {isOpen && (
//         <div className="accordion-content">
//           <div className="address-info">
//             <div>
//               <FormInputs
//                 label="Local Address"
//                 type="text"
//                 name="loc_add1"
//                 value={values.loc_add1}
//                 onChange={onChange}
//                 placeholder="Address line 1"
//                 maxlength="200"
//                 pattern="[A-Za-z0-9-, ]{1,200}"
//                 required
//               />
//             </div>
//             <div>
//               <FormInputs
//                 type="text"
//                 name="loc_add2"
//                 value={values.loc_add2}
//                 onChange={onChange}
//                 placeholder="Address line 2"
//                 maxlength="200"
//                 pattern="[A-Za-z0-9-, ]{1,200}"
//               />
//             </div>
//             <div className="grid-container-address">
//               <div className="search-form">
//                 <label>
//                   City/District <span className="city-required">*</span>
//                 </label>
//                 <div className="search-icon" ref={searchContainerRef}>
//                   <div style={{ position: "relative" }}>
//                     <input
//                       type="text"
//                       value={searchTerm}
//                       onChange={handleSearchChange}
//                       style={{ paddingRight: "30px" }}
//                     />
//                     <span className="search-button" onClick={handleSearchClick}>
//                       <img src={searchIcon} alt="search" />
//                     </span>
//                   </div>
//                   {filteredCity.length > 0 && (
//                     <div className="filter-search-items">
//                       {filteredCity.map((item, index) => (
//                         <div
//                           key={index}
//                           className="filter-items"
//                           onClick={() => handleItemClickOne(item)}
//                         >
//                           <p>{`${item.city_name}`}</p>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </div>
//               <div className="grid-item">
//                 <FormInputs
//                   label="State"
//                   type="text"
//                   value={stateName}
//                   disabled={selectedCity !== null}
//                 />
//               </div>
//               <div className="grid-item">
//                 <FormInputs
//                   label="Pin Code"
//                   type="text"
//                   name="loc_pincode"
//                   value={values.loc_pincode}
//                   onChange={onChange}
//                   maxLength={6}
//                   pattern="[0-9]{6}"
//                 />
//               </div>
//             </div>
//             <div
//               className="parmanent-add-checkbox"
//               style={{ marginTop: "70px" }}
//             >
//               <div style={{ position: "relative" }}>
//                 <div className="local-add-checkbox ">
//                   <label>Same as Local Address</label>
//                   <input
//                     type="checkbox"
//                     checked={sameAsLocal}
//                     onChange={handleCheckboxChange}
//                     className="cr-custom-checkbox"
//                   />
//                 </div>
//                 <FormInputs
//                   label="Permanent Address"
//                   type="text"
//                   name="perm_add1"
//                   value={values.perm_add1}
//                   onChange={onChange}
//                   placeholder="Address line 1"
//                   disabled={sameAsLocal}
//                   maxlength="200"
//                   pattern="[A-Za-z0-9-, ]{1,200}"
//                   required
//                 />
//                 <FormInputs
//                   type="text"
//                   name="perm_add2"
//                   value={values.perm_add2}
//                   onChange={onChange}
//                   placeholder="Address line 2"
//                   maxlength="200"
//                   pattern="[A-Za-z0-9-, ]{1,200}"
//                   disabled={sameAsLocal}
//                 />
//               </div>
//               <div className="grid-container-address">
//                 <div className="search-form">
//                   <label>
//                     City/District<span className="city-required">*</span>
//                   </label>
//                   <div className="search-icon" ref={searchPermCityRef}>
//                     <div style={{ position: "relative" }}>
//                       <input
//                         type="text"
//                         placeholder="Search..."
//                         value={searchPermCity}
//                         onChange={handleSearchChangePermCity}
//                         style={{ paddingRight: "30px" }}
//                       />
//                       <span
//                         className="search-button"
//                         onClick={handleSearchClickPermCity}
//                       >
//                         <img src={searchIcon} alt="search" />
//                       </span>
//                     </div>
//                     {filteredPermCity.length > 0 && (
//                       <div className="filter-search-items">
//                         {filteredPermCity.map((item, index) => (
//                           <div
//                             key={index}
//                             className="filter-items"
//                             onClick={() => handleItemClickPermCity(item)}
//                           >
//                             <p>{`${item.city_name}`}</p>
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//                 <div className="grid-item">
//                   <FormInputs
//                     label="State"
//                     type="text"
//                     value={stateNamePerm}
//                     disabled={selectedPermCity !== null}
//                   />
//                 </div>
//                 <div className="grid-item">
//                   <FormInputs
//                     label="Pin Code"
//                     type="text"
//                     name="perm_pincode"
//                     value={values.perm_pincode}
//                     onChange={onChange}
//                     maxLength={6}
//                     pattern="[0-9]{6}"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default Address;

import React, { useState, useEffect, useRef } from "react";
import "./registrationfrom.css";
import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
import EditIcon from "../../Assets/Images/EployeeRegistration/edit_icon.png";
import searchIcon from "../../Assets/Images/EployeeRegistration/search-icon.png";
import { API_BASE_URL } from "../../Config/Config";
import SearchDropdown from "../OTC/dropdownInput";

function Address({ setAddress }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCity, setFilteredCity] = useState([]);
  // const [selectedCity, setSelectedCity] = useState(null);
  // const [stateName, setStateName] = useState("");
  // New state for keyboard navigation in local search
  const [activeIndex, setActiveIndex] = useState(-1);
  // const [localCityOptions, setLocalCityOptions] = useState([]);

  const searchContainerRef = useRef(null);
  const [searchPermCity, setSearchPermCity] = useState("");
  const [filteredPermCity, setFilteredPermCity] = useState([]);
  // const [selectedPermCity, setSelectedPermCity] = useState(null);
  // const [stateNamePerm, setStateNamePerm] = useState("");
  // New state for keyboard navigation in permanent search
  const [activePermIndex, setActivePermIndex] = useState(-1);
  const searchPermCityRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [values, setValues] = useState({
    loc_add1: "",
    loc_add2: "",
    loc_city_id: 0,
    loc_pincode: "",
    perm_add1: "",
    perm_add2: "",
    perm_city_id: 0,
    perm_pincode: "",
  });

  // State for “same as local” checkbox
  const [sameAsLocal, setSameAsLocal] = useState(false);

  // Local city search states
  const [localCityOptions, setLocalCityOptions] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [stateName, setStateName] = useState("");

  // Permanent city search states
  const [permCityOptions, setPermCityOptions] = useState([]);
  const [selectedPermCity, setSelectedPermCity] = useState(null);
  const [stateNamePerm, setStateNamePerm] = useState("");

  // const [sameAsLocal, setSameAsLocal] = useState(false);

  setAddress(values);

  const onChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
    setAddress((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (event) => {
    setSameAsLocal(event.target.checked);
    if (event.target.checked) {
      setValues({
        ...values,
        perm_add1: values.loc_add1,
        perm_add2: values.loc_add2,
        perm_pincode: values.loc_pincode,
        perm_city_id: values.loc_city_id,
      });
      setSearchPermCity(searchTerm);
      setStateNamePerm(stateName);
      setSelectedPermCity(selectedCity);
    } else {
      setValues({
        ...values,
        perm_add1: "",
        perm_add2: "",
        perm_pincode: "",
        perm_city_id: "",
      });
      setSearchPermCity("");
      setStateNamePerm("");
    }
  };

  const handleItemClickOne = (item) => {
    setSelectedCity(item);
    setSearchTerm(item.city_name);
    setStateName(item.state_name);
    setFilteredCity([]);
    setActiveIndex(-1);
    setValues((prevValues) => ({
      ...prevValues,
      loc_city_id: item.city_id,
    }));
    setAddress((prevInfo) => ({
      ...prevInfo,
      loc_city_id: item.city_id,
    }));
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    // Reset active index when user types
    setActiveIndex(-1);
    if (value.trim() === "") {
      setFilteredCity([]);
      setSelectedCity(null);
      setStateName("");
    } else if (value.length >= 2) {
      handleSearchClick();
    }
  };

  console.log("Setting Perm City to:", selectedCity);

  const handleSearchClick = () => {
    if (searchTerm.trim() === "" || searchTerm.length < 2) {
      setFilteredCity([]);
      return;
    }
    // Using callback to ensure the latest value of searchTerm is used
    setSearchTerm((prevSearchTerm) => {
      fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-city-list-serach_key/?search_key=${encodeURIComponent(
          prevSearchTerm
        )}`
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          const filtered = data.filter((item) =>
            Object.values(item).some(
              (val) =>
                typeof val === "string" &&
                val.toLowerCase().includes(prevSearchTerm.toLowerCase())
            )
          );
          setFilteredCity(filtered);
          // Optionally, set activeIndex to first result
          setActiveIndex(filtered.length > 0 ? 0 : -1);
        })
        .catch((error) => {
          console.error("Error fetching city list:", error);
        });
      return prevSearchTerm;
    });
  };

  const handleKeyDownCity = (event) => {
    if (filteredCity.length === 0) return; // No suggestions available
    if (event.key === "ArrowDown") {
      event.preventDefault();
      setActiveIndex((prevIndex) =>
        prevIndex < filteredCity.length - 1 ? prevIndex + 1 : prevIndex
      );
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      setActiveIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : prevIndex
      );
    } else if (event.key === "Enter") {
      event.preventDefault();
      if (activeIndex >= 0 && filteredCity[activeIndex]) {
        handleItemClickOne(filteredCity[activeIndex]);
      }
    }
  };

  const handleClickOutside = (event) => {
    if (
      searchContainerRef.current &&
      !searchContainerRef.current.contains(event.target)
    ) {
      setFilteredCity([]);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // API CALL FOR PERMANENT CITY
  const handleSearchChangePermCity = (e) => {
    const value = e.target.value;
    setSearchPermCity(value);
    // Reset active index for permanent search when user types
    setActivePermIndex(-1);
    if (value.trim() === "") {
      setFilteredPermCity([]);
      setSelectedPermCity(null);
      setStateNamePerm("");
    } else if (value.length >= 3) {
      handleSearchClickPermCity();
    }
  };

  const handleSearchClickPermCity = () => {
    if (searchPermCity.trim() === "" || searchPermCity.length < 2) {
      setFilteredPermCity([]);
      return;
    }
    setSearchPermCity((prevSearchPermCity) => {
      fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-city-list-serach_key/?search_key=${encodeURIComponent(
          prevSearchPermCity
        )}`
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          const filtered = data.filter((item) =>
            Object.values(item).some(
              (val) =>
                typeof val === "string" &&
                val.toLowerCase().includes(prevSearchPermCity.toLowerCase())
            )
          );
          setFilteredPermCity(filtered);
          setActivePermIndex(filtered.length > 0 ? 0 : -1);
        })
        .catch((error) => {
          console.error("Error fetching permanent city list:", error);
        });
      return prevSearchPermCity;
    });
  };

  const handleKeyDownPermCity = (event) => {
    if (filteredPermCity.length === 0) return; // No suggestions available
    if (event.key === "ArrowDown") {
      event.preventDefault();
      setActivePermIndex((prevIndex) =>
        prevIndex < filteredPermCity.length - 1 ? prevIndex + 1 : prevIndex
      );
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      setActivePermIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : prevIndex
      );
    } else if (event.key === "Enter") {
      event.preventDefault();
      if (activePermIndex >= 0 && filteredPermCity[activePermIndex]) {
        handleItemClickPermCity(filteredPermCity[activePermIndex]);
      }
    }
  };
  // Helper function to fetch local city options from API
  const fetchLocalCityOptions = (inputText) => {
    if (inputText.trim().length < 2) {
      setLocalCityOptions([]);
      return;
    }
    fetch(
      `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-city-list-serach_key/?search_key=${encodeURIComponent(
        inputText
      )}`
    )
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((data) => {
        setLocalCityOptions(data);
      })
      .catch((error) => {
        console.error("Error fetching local city list:", error);
      });
  };

  const handleItemClickPermCity = (item) => {
    setSelectedPermCity(item);
    setSearchPermCity(item.city_name);
    setStateNamePerm(item.state_name);
    setFilteredPermCity([]);
    setActivePermIndex(-1);
    setValues((prevValues) => ({
      ...prevValues,
      perm_city_id: item.city_id,
    }));
    setAddress((prevInfo) => ({
      ...prevInfo,
      perm_city_id: item.city_id,
    }));
  };
  // Helper function to fetch permanent city options from API
  const fetchPermCityOptions = (inputText) => {
    if (inputText.trim().length < 2) {
      setPermCityOptions([]);
      return;
    }
    fetch(
      `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-city-list-serach_key/?search_key=${encodeURIComponent(
        inputText
      )}`
    )
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((data) => {
        setPermCityOptions(data);
      })
      .catch((error) => {
        console.error("Error fetching permanent city list:", error);
      });
  };
  const handleClickOutsidePerm = (event) => {
    if (
      searchPermCityRef.current &&
      !searchPermCityRef.current.contains(event.target)
    ) {
      setFilteredPermCity([]);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutsidePerm);
    return () => {
      document.removeEventListener("click", handleClickOutsidePerm);
    };
  }, []);

  return (
    <div className="personal-info">
      <div className="personal-header">
        <div className="header">
          <h2>ADDRESSES</h2>
          <img src={EditIcon} alt="icon" />
        </div>
        <div className="accordion-btn" onClick={toggleAccordion}>
          {isOpen ? (
            <div className="minus"></div>
          ) : (
            <div className="plus">+</div>
          )}
        </div>
      </div>
      {isOpen && (
        <div className="accordion-content">
          <div className="address-info">
            <div>
              <FormInputs
                label="Local Address"
                type="text"
                name="loc_add1"
                value={values.loc_add1}
                onChange={onChange}
                placeholder="Address line 1"
                maxlength="200"
                pattern="[A-Za-z0-9-, ]{1,200}"
                required
              />
            </div>
            <div>
              <FormInputs
                type="text"
                name="loc_add2"
                value={values.loc_add2}
                onChange={onChange}
                placeholder="Address line 2"
                maxlength="200"
                pattern="[A-Za-z0-9-, ]{1,200}"
              />
            </div>
            <div className="grid-container-address">
              {/* <div className="search-form">
                <label>
                  City/District <span className="city-required">*</span>
                </label>
                <div className="search-icon" ref={searchContainerRef}>
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      value={searchTerm}
                      onChange={handleSearchChange}
                      onKeyDown={handleKeyDownCity}
                      style={{ paddingRight: "30px" }}
                    />
                    <span className="search-button" onClick={handleSearchClick}>
                      <img src={searchIcon} alt="search" />
                    </span>
                  </div>
                  {filteredCity.length > 0 && (
                    <div className="filter-search-items">
                      {filteredCity.map((item, index) => (
                        <div
                          key={index}
                          className={`filter-items ${
                            index === activeIndex ? "active" : ""
                          }`}
                          onClick={() => handleItemClickOne(item)}
                        >
                          <p>{item.city_name}</p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div> */}
              <div className="selecte-dropdown-items">
                <SearchDropdown
                  initialOptions={localCityOptions}
                  onInputChange={fetchLocalCityOptions}
                  // onSelect={(option) => {
                  //   setSelectedCity(option);
                  //   setStateName(option.state_name);
                  //   setValues((prev) => ({
                  //     ...prev,
                  //     loc_city_id: option.city_id,
                  //   }));
                  //   setAddress((prev) => ({
                  //     ...prev,
                  //     loc_city_id: option.city_id,
                  //   }));
                  // }}
                  onSelect={(option) => {
                    if (option) {
                      setSelectedCity(option);
                      setStateName(option.state_name);
                      setValues((prev) => ({
                        ...prev,
                        loc_city_id: option.city_id,
                      }));
                      setAddress((prev) => ({
                        ...prev,
                        loc_city_id: option.city_id,
                      }));
                    } else {
                      // 🔴 Clear logic
                      setSelectedCity(null);
                      setStateName("");
                      setValues((prev) => ({
                        ...prev,
                        loc_city_id: 0,
                      }));
                      setAddress((prev) => ({
                        ...prev,
                        loc_city_id: 0,
                      }));
                    }
                  }}

                  placeholder="Search..."
                  label="City/District"
                  labelKey={(option) => option.city_name}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="State"
                  type="text"
                  value={stateName}
                  disabled={selectedCity !== null}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Pin Code"
                  type="text"
                  name="loc_pincode"
                  value={values.loc_pincode}
                  onChange={onChange}
                  maxLength={6}
                  pattern="[0-9]{6}"
                />
              </div>
            </div>
            <div
              className="parmanent-add-checkbox"
              style={{ marginTop: "30px" }}
            >
              <div style={{ position: "relative" }}>
                <div className="local-add-checkbox">
                  <label>Same as Local Address</label>
                  <input
                    type="checkbox"
                    checked={sameAsLocal}
                    onChange={handleCheckboxChange}
                    className="cr-custom-checkbox"
                  />
                </div>
                <FormInputs
                  label="Permanent Address"
                  type="text"
                  name="perm_add1"
                  value={values.perm_add1}
                  onChange={onChange}
                  placeholder="Address line 1"
                  disabled={sameAsLocal}
                  maxlength="200"
                  pattern="[A-Za-z0-9-, ]{1,200}"
                  required
                />
                <FormInputs
                  type="text"
                  name="perm_add2"
                  value={values.perm_add2}
                  onChange={onChange}
                  placeholder="Address line 2"
                  maxlength="200"
                  pattern="[A-Za-z0-9-, ]{1,200}"
                  disabled={sameAsLocal}
                />
              </div>
              <div className="grid-container-address">
                {/* <div className="search-form">
                  <label>
                    City/District<span className="city-required">*</span>
                  </label>
                  <div className="search-icon" ref={searchPermCityRef}>
                    <div style={{ position: "relative" }}>
                      <input
                        type="text"
                        placeholder="Search..."
                        value={searchPermCity}
                        onChange={handleSearchChangePermCity}
                        onKeyDown={handleKeyDownPermCity}
                        style={{ paddingRight: "30px" }}
                      />
                      <span
                        className="search-button"
                        onClick={handleSearchClickPermCity}
                      >
                        <img src={searchIcon} alt="search" />
                      </span>
                    </div>
                    {filteredPermCity.length > 0 && (
                      <div className="filter-search-items">
                        {filteredPermCity.map((item, index) => (
                          <div
                            key={index}
                            className={`filter-items ${index === activePermIndex ? "active" : ""}`}
                            onClick={() => handleItemClickPermCity(item)}
                          >
                            <p>{item.city_name}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div> */}
                <div className="selecte-dropdown-items">
                  <SearchDropdown
                    initialOptions={permCityOptions}
                    selected={selectedPermCity} // ✅ critical line
                    onInputChange={fetchPermCityOptions}
                    onSelect={(option) => {
                      if (option) {
                        setSelectedPermCity(option);
                        setStateNamePerm(option.state_name);
                        setValues((prev) => ({
                          ...prev,
                          perm_city_id: option.city_id,
                        }));
                        setAddress((prev) => ({
                          ...prev,
                          perm_city_id: option.city_id,
                        }));
                      } else {
                        // 🔴 Clear logic
                        setSelectedPermCity(null);
                        setStateNamePerm("");
                        setValues((prev) => ({
                          ...prev,
                          perm_city_id: 0,
                        }));
                        setAddress((prev) => ({
                          ...prev,
                          perm_city_id: 0,
                        }));
                      }
                    }}

                    placeholder="Search..."
                    label="City/District"
                    labelKey={(option) => option.city_name}
                  />
                </div>
                <div className="grid-item">
                  <FormInputs
                    label="State"
                    type="text"
                    value={stateNamePerm}
                    disabled={selectedPermCity !== null}
                  />
                </div>
                <div className="grid-item">
                  <FormInputs
                    label="Pin Code"
                    type="text"
                    name="perm_pincode"
                    value={values.perm_pincode}
                    onChange={onChange}
                    maxLength={6}
                    pattern="[0-9]{6}"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Address;
